module.exports = __webpack_public_path__ + "img/icon-sb-pwgd-blue-color-64x48.8711bb7.svg";